const options = { year: "numeric", month: "long", day: "numeric" };
export const dateFomat = ({ locale = "en-us", date }) => {
	return new Date(date).toLocaleString(locale, options);
};
